module.exports = {
  siteTitle: 'Healify', // <title>
  manifestName: 'Healify',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/healify/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Ready to feel great?',
  subHeading: 'Healify helps accelerate therapy results',
  subDescription: 'Measure and track your moods with ease. Use Healify with your therapist for 2.6x better results, and even between sessions to discover how to feel your best.',
  valueHeading: '5 minutes, twice a day',
  valueSubHeading: 'A mindfulness practice that actually delivers:',
  valueOneHeading: 'Reduce Stress',
  valueOneSub: 'Check in to the app anytime to understand how you’re feeling.',
  valueTwoHeading: 'Love yourself more',
  valueTwoSub: 'Track daily activities and changes. Discover what most helps you #shift.',
  valueThreeHeading: 'Optimize your care',
  valueThreeSub: 'Share your scores with your provider to feel better faster!',
  demoHeading: 'How healify works',
  demoSubHeading: 'Check in with yourself any time of day:',
  scienceHeading: 'The science behind Healify',
  scienceSubHeading: 'Check in with yourself any time of day:',
  scienceDescription: 'We have a dedicated team from Stanford, UC Berkeley, Apple, and Airbnb.  Our system is based on the pioneering work of David D. Burns, MD.  We have deep experience and research is core to what we do.',
  scienceOneHeading: '95% accuracy',
  scienceOneSub: 'Measure your mood using the most accurate tools known to science.',
  scienceTwoHeading: '2.6x better results',
  scienceTwoSub: 'People who track moods with Healify are 2.6x more likely to feel better.',
  scienceThreeHeading: '100% guaranteed',
  scienceThreeSub: 'Our providers all prove their results using our tools. Work with the best!',
  userFeedbackHeading: 'Our mission is to help you live your very best life.',
  userFeedbackDescription: '“Anytime I feel down or stuck, the Healify community is there to help lift me back up.love Healify!”',
  quoteHeading: '#shift happens',
  // social
  socialLinks: [
    {
      style: 'brands',
      icon: 'fa-medium',
      name: 'Medium',
      url: 'https://medium.com/heal-with-healify',
    },
    {
      style: 'solid',
      icon: 'fa-envelope',
      name: 'Email',
      url: 'mailto:support@healify.org',
    },
  ],
};
